import React from "react";
import { connect } from 'react-redux';
import Datetime from "react-datetime";
import moment from 'moment'



// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from '@material-ui/core/CircularProgress';
import Add from "@material-ui/icons/AddBox";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from "@material-ui/core/TextField";
import FormLabel from '@material-ui/core/FormLabel';



// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import SweetAlert from "react-bootstrap-sweetalert";


// style for this view
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

import { formatStatus } from "../../../utils/helpers";
import { registerUserRequest, registerUserReset } from "../../../actions/registerUser";
import { fetchCompaniesRequest } from "../../../actions/company";




const initialState = {
  firstName: '',
  middleName: '',
  lastName: '',
  passportNumber: '',
  nationalId: '',
  phoneNumber: '',
  dateOfBirth: '',
  role: '',
  comapany: '',
  email: '',
  password: '',
  confirmPassword: '',
  error: {},
  success: false,
  showPasswords: false,
  identification: true,
  isExternalUser: null,
};

class RegisterUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentWillMount() {
    this.props.dispatch(fetchCompaniesRequest());

  }

  componentDidUpdate() {
    if (this.props.registerUserData.registerUserSuccess) {
      this.setState({ ...initialState, success: true });
      this.props.dispatch(registerUserReset());
    }
  }


  handleTextChange(field, event) {
    const { value } = event.target;
    let { error } = this.state
    const newError = { ...error, [field]: false }

    if (field == 'email') {
      if (!this.verifyEmail(value)) {
        const newError = { ...error, [field]: true }

        this.setState({ [field]: value, error: newError });
      } else {

        this.setState({ [field]: value, error: newError });
      }
    }


    else {

      this.setState({ [field]: value, error: newError });
    }
  }
  dateHandler(date) {
    const formatedDate = date.format('YYYY-MM-DD')
    this.setState({ dateOfBirth: formatedDate })

  }

  showHidePassword(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ showPasswords: !this.state.showPasswords })
  }

  verifyEmail(value) {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }

  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }

  passwordsMatch(password1, password2) {
    if (password1 === password2 && this.verifyLength(password1, 6) && this.verifyLength(password2, 6)) {
      return true;
    }

    return false;
  }

  reset() {
    this.props.dispatch(registerUserReset())
  }

  validateJobCardForm() {

    let errorFlag = false;
    let newError = this.state.error;
    if (!this.state.firstName) {
      newError.firstName = true;
      errorFlag = true;
    }
    if (!this.state.lastName) {
      newError.lastName = true;
      errorFlag = true;
    }

    if(this.validateIdentification()){
      // newError.nationalId = true
      errorFlag = true
    }

    if (!this.state.role) {
      newError.role = true;
      errorFlag = true;
    }

    if (!this.state.role) {
      newError.role = true;
      errorFlag = true;
    }

    if (this.state.isExternalUser == null) {
      newError.isExternalUser = true;
      errorFlag = true;
    }else {
      newError.isExternalUser = false;
      errorFlag = false;
    }

    if (!this.state.email) {
      newError.email = true;
      errorFlag = true;
    }
    if (!this.state.password) {
      newError.password = true;
      errorFlag = true;
    }

    if (!this.state.confirmPassword) {
      newError.confirmPassword = true;
      errorFlag = true;
    }
    if (!this.passwordsMatch(this.state.password, this.state.confirmPassword)) {
      newError.confirmPassword = true;
      newError.password = true;

      errorFlag = true;
    }

    this.setState({ error: newError });
    return errorFlag;
  }
  validateIdentification(){
    let errorFlag = false;
    let newError = this.state.error;
    if(this.state.identification){
      if (!this.state.nationalId || !this.checkLenght(this.state.nationalId, 13) || !this.validateIdAgainstDob(this.state.nationalId, this.state.dateOfBirth)) {
        newError.nationalId = true;
        errorFlag = true;
        this.setState({ error: newError });
        return true

      }
    }else{
      if (!this.state.passportNumber || !this.checkLenght(this.state.passportNumber, 5)) {
        newError.passportNumber = true;
        errorFlag = true;
        this.setState({ error: newError });
       return true

      }
    }
    return false
  }
  validateIdAgainstDob(id, d){
    if(!d){
      return false
    }
    const year = d.substring(2,4)
    const month = d.substring(5,7)
    const day = d.substring(8, 10)
    const dob = year+month+day
    const dobInId = id.toString().substring(0,6);
    console.log(dob,dobInId)
    return dob===dobInId
  }

  checkLenght(valueToCheck, lengthNumber){
   return (valueToCheck.length >= lengthNumber)

  }
  createUser() {
    console.log("testing payload", this.validateJobCardForm())
    if (this.validateJobCardForm()) {
      return;
    }


    let payload = {
      firstName: this.state.firstName,
      middleName: this.state.middleName,
      lastName: this.state.lastName,

      phoneNumber: this.state.phoneNumber,
      role: this.state.role,
      companyId: this.state.comapany,
      email: this.state.email,
      password: this.state.password,
      confirmPassword: this.state.confirmPassword,
      dob: this.state.dateOfBirth + "T00:00:00.000Z",   //TODO: we should fix the date on the api side to take the format 'YYYY-MM-DD'
      employeeID: "string",
      external: this.state.isExternalUser

    }
    if(this.state.identification){
      payload.nationalId = parseInt(this.state.nationalId)
    }
    else{
      payload.passportNumber = this.state.passportNumber
    }
    console.log("payload", payload);
    this.props.dispatch(registerUserRequest(payload));

  }
  handleIdType(event) {
    const isSuccess = (event.target.value == 'id') ? true : false
    this.setState({ [event.target.name]: isSuccess });
  }

  handleIsExternalUser(event) {
    const isExternal = (event.target.value == 'externalUser') ? true : false
    this.setState({ [event.target.name]: isExternal });
  }

  handleIdentificationChange(field, event){
    const { value } = event.target
    let { error } = this.state
    const newError = { ...error, [field]: false }
    if(field === "nationalId" && value.length<=13){
      this.setState({ [field]: value, error: newError });
    }
  }

  render() {
    const { classes } = this.props;

    const roles = ["Administrator", "Management", "Technician", "Auditor", "StockController", "Inspector"]
    const companiesList = this.props.companyData.companies || [];
    let e = []
    if (this.props.registerUserData.registerUserErrors) {
      const apiErrors = this.props.registerUserData.registerUserErrors
      const apiErrors2 = this.props.registerUserData.registerUserErrors.message || []

      console.log(apiErrors);

      let i;
      let error;
      if (apiErrors2) {
        e.push(apiErrors2)
      }
      for (i = 0; i < apiErrors.length; i++) {
        console.log(apiErrors[i].constraints[0]);
        error = (apiErrors[i].constraints)
        e.push(Object.values(error) + ';     ')
      }
      console.log("api errors: ", e);

    }

    const successButtonStyle = {
      backgroundColor: "#4CAF50", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"
    }

    const dangerButtonStyle = {
      backgroundColor: "red", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"
    }

    return (
      <div>
        {this.state.success ? <SweetAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="User Created Successfully!"
          onConfirm={() => this.setState({ success: false })}
          onCancel={() => this.setState({ success: false })}
          confirmBtnStyle={successButtonStyle}
        >

        </SweetAlert> : ''}
        {this.props.registerUserData.registerUserErrors ? <SweetAlert
          danger
          style={{ display: "block", marginTop: "-100px" }}
          title="Register Error"
          onConfirm={() => this.props.dispatch(registerUserReset())}
          onCancel={() => this.props.dispatch(registerUserReset())}
          confirmBtnStyle={dangerButtonStyle}
        >
          {
            this.props.registerUserData.registerUserErrors ?
              e.map((item, index) => {
                return <p key={index}> {item}</p>
              }) : 'An unexpected error occured'}
        </SweetAlert> : ''}

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardText color="info">
                  <h4>Personal Info</h4>
                </CardText>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.firstName}
                        labelText="First Name  *"
                        id="firstName"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.firstName,
                          onChange: this.handleTextChange.bind(this, 'firstName'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.middleName}
                        labelText="Middle Name "
                        id="middleName"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.middleName,
                          onChange: this.handleTextChange.bind(this, 'middleName'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.lastName}
                        labelText="Last Name  *"
                        id="lastName"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.lastName,
                          onChange: this.handleTextChange.bind(this, 'lastName'),
                        }}
                      />
                    </GridItem>


                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        error={this.state.error.phoneNumber}
                        labelText="Phone Number*"
                        id="phoneNumber"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",
                          value: this.state.phoneNumber,
                          onChange: this.handleTextChange.bind(this, 'phoneNumber'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <br />
                      <FormControl fullWidth>
                        <Datetime
                          timeFormat={false}
                          name={this.state.dateOfBirth}
                          onChange={this.dateHandler.bind(this)}
                          value={this.state.dateOfBirth || ""}
                          inputProps={{ placeholder: "Date of Birth*" }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <div >
                        <br />
                       
                        <FormControl component="fieldset" >
                          <RadioGroup
                            aria-label="Job Status"
                            name="identification"
                            value={this.value}
                            onChange={this.handleIdType.bind(this)}
                             row
                          >
                           <FormControlLabel value={'id'} control={<Radio />} label="National ID" />  
                           <FormControlLabel value={'passport'} control={<Radio />} label="Passport" />  
                          </RadioGroup>
                        </FormControl>
                      </div>
                      <div >
                        {(this.state.identification === true) ? <GridItem xs={12} sm={6} md={6}>
                          <CustomInput
                            error={this.state.error.nationalId}
                            labelText="National Id  *"
                            id="nationalId"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              type: "number",
                              value: this.state.nationalId,
                              onChange: this.handleIdentificationChange.bind(this, 'nationalId'),
                            }}
                          />
                        </GridItem> : <GridItem xs={12} sm={6} md={6}>
                            <CustomInput
                              error={this.state.error.passportNumber}
                              labelText="Passport Number*"
                              id="passportNumber"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                type: "text",
                                value: this.state.passportNumber,
                                onChange: this.handleTextChange.bind(this, 'passportNumber'),
                              }}
                            />
                          </GridItem>}
                        <br />
                      </div>
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
          

          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardText color="info">
                  <h4>Company and Role</h4>
                </CardText>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="simple-select"
                        >
                          Choose User ROLE *
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.role}
                          error={this.state.error.role}
                          onChange={this.handleTextChange.bind(this, 'role')}
                          inputProps={{
                            name: "role",
                            id: "role"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select role
                        </MenuItem>
                          {
                            roles.map((role, index) =>
                              <MenuItem
                                key={index}
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={role}
                              >
                                {formatStatus(role)}
                              </MenuItem>
                            )
                          }
                        </Select>
                      </FormControl>

                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                      <FormControl
                        fullWidth
                      >
                        <InputLabel
                          htmlFor="simple-select"
                        >
                          Assign Company *
                      </InputLabel>
                        <Select
                          classes={{
                            select: classes.select
                          }}
                          value={this.state.comapany}
                          error={this.state.error.comapany}
                          onChange={this.handleTextChange.bind(this, 'comapany')}
                          inputProps={{
                            name: "comapany",
                            id: "comapany"
                          }}
                        >
                          <MenuItem
                            disabled
                          >
                            Select Company
                        </MenuItem>
                          {
                            companiesList.map((company, index) =>
                              <MenuItem
                                key={index}
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                value={company._id}
                              >
                                {formatStatus(company.comapanyName)}
                              </MenuItem>
                            )
                          }
                        </Select>
                      </FormControl>
                    </GridItem>

<GridItem>
<div >
                        <br />
                       
                        <FormControl component="fieldset" >
                          <RadioGroup
                            aria-label="user Status"
                            name="isExternalUser"
                            value={this.value}
                            onChange={this.handleIsExternalUser.bind(this)}
                             row
                          >
                           <FormControlLabel value={'externalUser'} control={<Radio />} label="External User" />  
                           <FormControlLabel value={'internalUser'} control={<Radio />} label="Internal User" />  
                          </RadioGroup>
                        </FormControl>
                        <p 
                        style={{
                          color:"red",
                          display:
                            this.state.error.isExternalUser
                              ? 'block'
                              : 'none',
                        }}
                        > Please select external or internal user</p>
                      </div>
</GridItem>


                  </GridContainer>

                </form>
              </CardBody>
            </Card>
          </GridItem>

          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardText color="info">
                  <h4>User Credentials</h4>
                </CardText>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.email}
                        labelText="Email"
                        id="email"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "email",
                          value: this.state.email,
                          onChange: this.handleTextChange.bind(this, 'email'),
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.password}
                        labelText="Password  *"
                        id="password"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: this.state.showPasswords ? 'text' : 'password',
                          value: this.state.password,
                          onChange: this.handleTextChange.bind(this, 'password'),
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        error={this.state.error.confirmPassword}
                        labelText="Confirm Password *"
                        id="confirmPassword"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: this.state.showPasswords ? 'text' : 'password',
                          value: this.state.confirmPassword,
                          onChange: this.handleTextChange.bind(this, 'confirmPassword'),
                          endAdornment: (
                            <InputAdornment
                              position="end"
                              className={classes.inputAdornment}
                            >
                              {
                                this.state.showPasswords ? <Visibility onClick={this.showHidePassword.bind(this)} className={classes.inputAdornmentIcon} /> :
                                  <VisibilityOff onClick={this.showHidePassword.bind(this)} className={classes.inputAdornmentIcon} />
                              }

                            </InputAdornment>
                          )

                        }}
                      />
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>


        </GridContainer>
        <div style={{ textAlign: "center" }}>

          {
            this.props.registerUserData.registerUserLoader ?
              (<CircularProgress />) :
              (
                <Button color="info" onClick={this.createUser.bind(this)}>
                  <Add />
                  Register User
            </Button>
              )
          }
        </div>
      </div>
    );
  }
}

export default withStyles(extendedFormsStyle)(
  connect(state => ({
    companyData: state.companyState,
    registerUserData: state.registerUserState,
  }))(RegisterUser)
);
